import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const MIN_WIDTH = 1200

export default function initParallax() {
  if (window.innerWidth <= MIN_WIDTH) return

  document.querySelectorAll('[class*="parallax-"]').forEach((el) => {
    const match = Array.from(el.classList)
      .map(cls => cls.match(/^parallax-(n-)?(\d+)$/))
      .find(Boolean)

    if (!match) return

    const [, negative, value] = match
    const yPercent = negative ? -Number(value) : Number(value)

    gsap.to(el, {
      yPercent,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        scrub: 3,
      },
    })
  })
}
